import React, {Component} from "react";
import {isEmpty, map} from "lodash";
import { formatToCurrency } from "../../../../../../../Tools/formatToCurrency";

import cross_icon from '../../../../../../../Assets/images/cross_icon.svg';
import visa from "../../../../../../../Assets/images/visa_dark.svg";
import american from "../../../../../../../Assets/images/american_express_dark.svg";

const frequency_data = [
  {key: 'Twice Weekly', value: 'twice_weekly'},
  {key: 'Weekly', value: 'weekly'},
  {key: 'Every Other Week', value: 'bi_monthly'},
  {key: 'Monthly', value: 'monthly'},
  {key: 'One-Time', value: 'once'},
]

// mapping property type
const property_type = [
  {key: 'Town House', value: 'townhouse'},
  {key: 'Detached', comment: '<.5 acres. lot', value: 'single_family_small'},
  {key: 'Detached', comment: '>.5 acres. lot - FO to assess', value: 'single_family_large'},
]

const area_clean = [
  { key: 'Front Yard', value: 'front yard'},
  { key: 'Back Yard', value: 'back yard'},
  { key: 'Right Side', value: 'right side'},
  { key: 'Left Side', value: 'left side'},
  { key: 'Dog Run', value: 'dog run'},
  { key: 'Fenced Area', value: 'fenced area'},
  { key: 'Other', value: ''},
];

const last_cleaned = [
  { key: 'Less than 2 weeks', value: 'less_than_2_weeks'},
  { key: '2 to 6 weeks', value: '1-2_months'},
  { key: 'More than 6 weeks', value: '2_months_or_more'}
]

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isApplyCoupon: false,
      coupon_code: '',
      couponCodeError: '',
      prepay_months: null,
      isPrePay: false,
      PricingCalcData: {},
    }
  }

  componentDidMount = () => {
    const { serviceOrderEnquiry } = this.props;
    if (serviceOrderEnquiry) {
      this.setState({
        coupon_code: serviceOrderEnquiry?.enquiryList?.results[0]?.coupon_code, //calcData?.coupon_code,
        prepay_months: serviceOrderEnquiry?.enquiryList?.results[0]?.prepay_months, //calcData?.prepay_months,
        isPrePay: serviceOrderEnquiry?.enquiryList?.results[0]?.is_prepaid,
      }, () => {
        // TODO:
      })
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // pricing calc errors
    if (Object.keys(nextProps?.PricingCalc?.errors).length > 0 && nextProps?.PricingCalc?.errors !== this.props?.PricingCalc?.errors) {
      this.setState({couponCodeError: nextProps.PricingCalc?.errors?.coupon_code?.[0]})
    }

    if (Object.keys(nextProps?.PricingCalc?.data).length > 0 && nextProps?.PricingCalc?.data !== this.props?.PricingCalc.data) {
      this.setState({couponCodeError: '', isApplyCoupon: false, coupon_code: '', coupon_applied: nextProps?.PricingCalc?.data?.coupon_applied})
    }
  }

  // on service detail change
  onTextChange = (e, type, pricingCalc) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value, isLocalChange: true }, () => {
      const {coupon_code, prepay_months, isPrePay} = this.state;
      sessionStorage.setItem('calcData', JSON.stringify({coupon_code, prepay_months, isPrePay}))
      if (pricingCalc) sessionStorage.setItem('PricingCalc', JSON.stringify(pricingCalc))
      this.props.priceCalc({coupon_code, prepay_months, isPrePay})
    })
  }

  onTextChangePrepay = (e, type, pricingCalc) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    if (value) {
      this.setState({ [e.target.name]: value }, () => {
        const {coupon_code, prepay_months, isPrePay} = this.state;
        sessionStorage.setItem('calcData', JSON.stringify({coupon_code, prepay_months, isPrePay}))
        if (pricingCalc) sessionStorage.setItem('PricingCalc', JSON.stringify(pricingCalc))
        this.props.priceCalc({coupon_code, prepay_months, isPrePay})
      })
    } else {
      this.setState({ [e.target.name]: value, prepay_months: null }, () => {
        const { coupon_code } = this.state;
        sessionStorage.setItem('calcData', JSON.stringify({coupon_code, prepay_months: null, isPrePay: false}))
        if (pricingCalc) sessionStorage.setItem('PricingCalc', JSON.stringify(pricingCalc))
        this.props.priceCalc({coupon_code, prepay_months: null, isPrePay: false})
      })
    }
  }

  // toggle coupon
  toggleCoupon = (value) => {
    this.setState({isApplyCoupon: value})
  }

  // on add coupon
  onAddCoupon = () => {
    const {coupon_code, prepay_months, isPrePay} = this.state;
    this.props.setCouponCode && this.props.setCouponCode(coupon_code)
    sessionStorage.setItem('calcData', JSON.stringify({coupon_code, prepay_months, isPrePay}))
    this.props.priceCalc({coupon_code, prepay_months, isPrePay})
  }

  renderSummary = () => {
    const {isApplyCoupon, coupon_code, couponCodeError, prepay_months, isPrePay} = this.state;
    const {PricingCalc} = this.props;
    const step1Data = JSON.parse(sessionStorage.getItem('step1'));
    const pricingCalc = JSON.parse(sessionStorage.getItem('pricingCalc'));
    const {frequency = '', propertyType = '', dogCount = '', lastCleaned = '', extra_pet = '', is_extra_pet = false} = step1Data || {};
    const PricingCalcData = PricingCalc?.data || pricingCalc || {};
    const frequencyValue = frequency_data.filter(obj => obj.value === frequency);
    const propertyValue = property_type.filter(obj => obj.value === propertyType);
    const diaplyLastCleanedValue = last_cleaned.filter(obj => obj.value === lastCleaned);
    const areaCleanValue = area_clean.filter(obj => PricingCalcData?.cleaning_areas?.items?.[0]?.area === obj.value);
    const isExistPricingData = Object.keys(PricingCalcData).length > 0
    return (
      <div className="aside-bar">
        <div className="acol">
          <h2 className="mb-20">Service Summary</h2>
          <h4>Subscription details</h4>
          {
            isExistPricingData &&
            <div className="flex">
              <div className="flex-1">
                <p>{`${frequencyValue?.[0]?.key || ''} service, ${areaCleanValue?.[0]?.key || ''} ${propertyValue?.[0]?.key || ''}  ${propertyValue?.[0]?.comment ? `(${propertyValue?.[0]?.comment})` : ''}`}</p>
                <p>{is_extra_pet ? `${extra_pet} dogs` : `${dogCount} ${dogCount === '1' ? 'Dog' : 'Dogs'}`}</p>
              </div>
              {isExistPricingData && <div className=""><b>${PricingCalcData?.service_base_price}</b></div>}
            </div>
          }
          <hr/>
          {
            map(PricingCalcData?.cleaning_areas?.items, (item, i) => {
              if (i !== 0) {
                return (
                  <div className="flex" key={`clean_area${i}`}>
                    <div className="flex-1" key={`cleaning_areas${i}`}>
                      <p>{item.area ? item.area : 'Other'}</p>
                    </div>
                    <div className=""><b>+${item?.price || '0'}</b></div>
                  </div>
                )
              }
            })
          }
          {map(PricingCalcData && PricingCalcData.recurring_add_ons && PricingCalcData.recurring_add_ons.recurring_addon_items, (item, i) => {
            if (item.type === 'add_on') {
              return (
                <div className="flex" key={`recurring_add_ons${i}`}>
                  <div className="flex-1">
                    <p>{item.name}</p>
                  </div>
                  <div className=""><b>+${item.price}</b></div>
                </div>
              )
            }
          })
          }
          <div className="highlight">
            <div className="flex">
              <div className="flex-1">
                {frequency === "once" ? <h4 className="m-0">Price for a single visit</h4> :
                  <h4 className="m-0">Price per {frequencyValue?.[0]?.key?.toLowerCase()} visit</h4> }
                {isExistPricingData ? <p>{`Billed ${frequency === 'once' ? 'Just Once' : 'Monthly'}`}</p> : <p />}
              </div>
              {isExistPricingData && <div className="pricing"><b>+${PricingCalcData?.total_price_per_service}</b></div>}
            </div>
            <div className="flex">
              <div className="flex-1">
                <h4 className="m-0">Prepay and save up to 10%</h4>
              </div>
              <div className="chk_switch">
                <div className="can-toggle can-toggle--size-small">
                  <input className="fitem-ck-input" id="prepay_for_year" type="checkbox" name={"isPrePay"} checked={!isPrePay} onChange={(e) => { this.onTextChangePrepay({target: {name: 'isPrePay', value: !e.target.checked}}) }} />
                  <label htmlFor="prepay_for_year" className="fitem-ck-txt black">
                    <div className="can-toggle__switch"
                      data-unchecked="Yes"
                      data-checked="No"
                    />
                  </label>
                </div>
              </div>
            </div>
            {
              (isPrePay && isExistPricingData) && <div className="price_type">
                <div className="inline-check-list">
                  <div className="flex mt-10">
                    <div className="fitem-check mr-2"><input className="fitem-ck-input" id="6_month" checked={+prepay_months === 6} value="6" name="prepay_months" type="radio" onChange={(e) => this.onTextChange(e)} />
                      <label htmlFor="6_month" className="fitem-ck-txt">
                        Price for 6 months
                        <span> Save ${formatToCurrency(PricingCalcData?.prepay_price?.six_months?.savings)} (5%)</span>
                      </label>
                    </div>
                    <h3 className="price success">${formatToCurrency(PricingCalcData?.prepay_price?.six_months?.total_price_per_service)}</h3>
                  </div>
                  <div className={+prepay_months === 12 || prepay_months === null ? 'flex mt-10' : 'flex mt-10 disble_sub_type'}>
                    <div className="fitem-check mr-2"><input className="fitem-ck-input" id="12_month" checked={+prepay_months === 12} value="12" name="prepay_months" type="radio" onChange={(e) => this.onTextChange(e)} />
                      <label htmlFor="12_month" className="fitem-ck-txt">
                        Price for 1 year
                        <span> Save ${formatToCurrency(PricingCalcData?.prepay_price?.twelve_months?.savings)} (10%)</span>
                      </label>
                    </div>
                    <h3 className="price success">${formatToCurrency(PricingCalcData?.prepay_price?.twelve_months?.total_price_per_service)}</h3>
                  </div>
                </div>
              </div>
            }
          </div>
          <div className="flex mt-30">
            <div className="flex-1">
              <h4 className="mb-0">One-time charge(s)</h4>
              {PricingCalcData.cleaning_areas ? map(PricingCalcData && PricingCalcData.one_time_charges && PricingCalcData.one_time_charges.one_time_items, (item, i) => {
                if (item.type === 'last_clean') {
                  const lastCleanedValue = last_cleaned.filter(obj => obj.value === item.name);
                  return <p key={`cleaning${i}`}>{lastCleanedValue?.[0]?.key} since last clean</p>
                }
                return <p key={`cleaning${i}`}>{item.name} since last clean</p>
              }) : isExistPricingData ? <p>{diaplyLastCleanedValue?.[0]?.key} since last clean</p> : ''
              }
            </div>
            {isExistPricingData && <div className=""><b>+${PricingCalcData?.one_time_charges?.total_one_time_charge}</b></div>}
          </div>
          <div className="wlight">
            <div className="flex ai-center">
              <div className="flex-1">
                <h4 className="m-0">Total for first visit</h4>
              </div>
              {isExistPricingData && +prepay_months === 6 && <div className="pricing"><b>+${PricingCalcData?.prepay_price?.six_months?.total_price_for_first_visit}</b></div>}
              {isExistPricingData && +prepay_months === 12 && <div className="pricing"><b>+${PricingCalcData?.prepay_price?.twelve_months?.total_price_for_first_visit}</b></div>}
              {isExistPricingData && isPrePay && !prepay_months && <div className="pricing"><b>+${PricingCalcData?.total_price_for_first_visit}</b></div>}
              {isExistPricingData && !isPrePay && !prepay_months && <div className="pricing"><b>+${PricingCalcData?.total_price_for_first_visit}</b></div>}
            </div>
            {!isEmpty(PricingCalcData?.coupon?.coupon_applied) ?
              <div className="applied_coupon_code flex mt-20">
                <div>
                  <img src={cross_icon} className="mr-1 cross_icon" alt="" onClick={() => {
                    this.toggleCoupon(false);
                    this.onTextChange({target: {name: 'coupon_code', value: ''}})
                  }} />
                </div>
                <div style={{flex: "auto", marginLeft: "10px"}}><label style={{marginRight: "5px"}}>{PricingCalcData?.coupon?.coupon_applied}</label><span>Applied</span></div>
                <div className="discount_price">{PricingCalcData?.coupon?.savings ? `-$${PricingCalcData?.coupon?.savings}` : '$0'}</div>
              </div>
              : ''}
          </div>
          {
            isApplyCoupon ?
              <div className="form-group flex">
                <div className={"fitem"} style={{marginTop: "20px"}}>
                  <a href="/#" onClick={(e) => {
                    e.preventDefault(); this.toggleCoupon(false);
                    this.setState({couponCodeError: ''})
                  }} className="btn plain-btn remove-copupon"><img src={cross_icon} alt="" className="remove_contact" /></a>
                </div>
                <div className='fitem fitem-rinner mt-10 flex-1'>
                  <input type="text"
                    className={couponCodeError ? 'error_control' : ''}
                    name="coupon_code"
                    value={coupon_code}
                    placeholder="Add Coupon"
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value }) }
                  />
                  <a href="/#" onClick={(e) => { e.preventDefault();
                    this.onAddCoupon()
                  }} className="btn btn-warning fitem-ricon">
                    <i className="las la-plus"></i></a>
                </div>
              </div> :
              <div className="flex flex-start ai-center mt-30 cursor_pointer" onClick={() => this.toggleCoupon(true)}>
                <i className="las la-plus-circle orange"/> &nbsp;&nbsp; Add a coupon
              </div>
          }
          {(couponCodeError) ? <label className="new_err_msg"><i className="las la-info-circle"/>{couponCodeError}</label> : ''}
        </div>
      </div>
    );
  }

  renderConfirmation = () => {
    const { prepay_months, isPrePay } = this.state;
    const {PricingCalc, cardDetail} = this.props;
    const basicDetail = JSON.parse(sessionStorage.getItem('basicDetail'));
    const step1Data = JSON.parse(sessionStorage.getItem('step1'));
    const step2Data = JSON.parse(sessionStorage.getItem('step2'));
    const pricingCalc = JSON.parse(sessionStorage.getItem('pricingCalc'));
    const {frequency = '', propertyType = '', dogCount = '', lastCleaned = ''} = step1Data || {};
    const PricingCalcData = PricingCalc?.data || pricingCalc || {};
    const frequencyValue = frequency_data.filter(obj => obj.value === frequency);
    const propertyValue = property_type.filter(obj => obj.value === propertyType);
    const diaplyLastCleanedValue = last_cleaned.filter(obj => obj.value === lastCleaned);
    const areaCleanValue = area_clean.filter(obj => PricingCalcData?.cleaning_areas?.items?.[0]?.area === obj.value);
    const isExistPricingData = Object.keys(PricingCalcData).length > 0;
    const billing_address = step2Data?.isBillingAddress ? basicDetail?.address : step2Data?.address;
    let addressStr = (billing_address?.street_number && billing_address?.route) ? `${step2Data?.address?.street_number} ${step2Data?.address?.route}` : billing_address?.address;
    addressStr += billing_address?.city ? `, ${billing_address?.city}` : '';
    addressStr += billing_address?.state ? `, ${billing_address?.state}` : '';
    addressStr += billing_address?.zip_code ? `, ${billing_address?.zip_code}` : '';

    return (
      <div className="aside-bar">
        <div className="acol">
          <h2 className="mb-20">Your service confirmed!</h2>
          <h4>Billing details</h4>
          <div className={"d-block"}>
            <div className="card_img flex ai-center flex-start">
              {cardDetail?.user_billing_info?.stripe_card_details?.brand === 'visa' ?
                <img src={visa} alt="" /> :
                <img src={american} alt="" />} &nbsp;&nbsp;
              <label className="m-0">{`${cardDetail?.user_billing_info?.stripe_card_details?.brand} ending in ${cardDetail?.user_billing_info?.stripe_card_details?.last4}`}</label>
            </div>
            <p className="mt-10">{addressStr}</p>
          </div>
          <hr/>
          <h4>Subscription details</h4>
          {
            isExistPricingData &&
            <div className="flex">
              <div className="flex-1">
                <p>{`${frequencyValue?.[0]?.key} service, ${areaCleanValue?.[0]?.key} ${propertyValue?.[0]?.key}  ${propertyValue?.[0]?.comment ? `(${propertyValue?.[0]?.comment})` : ''}`}</p>
                <p>{`${dogCount} ${dogCount === '1' ? 'Dog' : 'Dogs'}`}</p>
              </div>
              {isExistPricingData && <div className=""><b>${PricingCalcData?.service_base_price}</b></div>}
            </div>
          }
          <hr/>
          {
            map(PricingCalcData?.cleaning_areas?.items, (item, i) => {
              if (i !== 0) {
                return (
                  <div className="flex">
                    <div className="flex-1" key={`cleaning_areas${i}`}>
                      <p>{item.area ? item.area : 'Other'}</p>
                    </div>
                    <div className=""><b>+${item.price}</b></div>
                  </div>
                )
              }
            })
          }
          {map(PricingCalcData && PricingCalcData.recurring_add_ons && PricingCalcData.recurring_add_ons.recurring_addon_items, (item, i) => {
            if (item.type === 'add_on') {
              return (
                <div className="flex" key={`recurring_add_ons${i}`}>
                  <div className="flex-1">
                    <p>{item.name}</p>
                  </div>
                  <div className=""><b>+${item.price}</b></div>
                </div>
              )
            }
          })
          }
          <div className="highlight">
            <div className="flex">
              <div className="flex-1">
                {frequency === "once" ? <h4 className="m-0">Price for a single visit</h4> :
                  <h4 className="m-0">Price per {frequencyValue?.[0]?.key?.toLowerCase()} visit</h4> }
                <p>{`Billed ${frequency === 'once' ? 'Just Once' : 'Monthly'}`}</p>
              </div>
              {isExistPricingData && <div className="pricing"><b>+${PricingCalcData?.total_price_per_service}</b></div>}
            </div>
          </div>
          <div className="flex mt-30">
            <div className="flex-1">
              <h4 className="mb-0">One-time charge(s)</h4>
              {PricingCalcData.cleaning_areas ? map(PricingCalcData && PricingCalcData.one_time_charges && PricingCalcData.one_time_charges.one_time_items, (item, i) => {
                if (item.type === 'last_clean') {
                  const lastCleanedValue = last_cleaned.filter(obj => obj.value === item.name);
                  return <p key={`cleaning${i}`}>{lastCleanedValue?.[0]?.key} since last clean</p>
                }
                return <p key={`cleaning${i}`}>{item.name} since last clean</p>
              }) : <p>{diaplyLastCleanedValue?.[0]?.key} since last clean</p>
              }
            </div>
            {isExistPricingData && <div className=""><b>+${PricingCalcData?.one_time_charges?.total_one_time_charge}</b></div>}
          </div>
          <div className="wlight">
            <div className="flex ai-center">
              <div className="flex-1">
                <h4 className="m-0">Total for first visit</h4>
              </div>
              {/* {isExistPricingData && <div className="pricing"><b>+${PricingCalcData?.total_price_for_first_visit}</b></div>} */}
              {isExistPricingData && +prepay_months === 6 && <div className="pricing"><b>+${PricingCalcData?.prepay_price?.six_months?.total_price_for_first_visit}</b></div>}
              {isExistPricingData && +prepay_months === 12 && <div className="pricing"><b>+${PricingCalcData?.prepay_price?.twelve_months?.total_price_for_first_visit}</b></div>}
              {isExistPricingData && isPrePay && !prepay_months && <div className="pricing"><b>+${PricingCalcData?.total_price_for_first_visit}</b></div>}
              {isExistPricingData && !isPrePay && !prepay_months && <div className="pricing"><b>+${PricingCalcData?.total_price_for_first_visit}</b></div>}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return this.renderSummary()
  }
}

export default SideBar;